import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from '../pages/Home/Home';
import NavBar from './NavBar/NavBar';
import ScrollToTop from '../components/ScrollToTop';
import Footer from 'components/Footer/Footer';
import Dogs from 'pages/Dogs/Dogs';
import MajorAndJazz from 'pages/MajorAndJazz/MajorAndJazz';
import Contacts from 'pages/Contacts/Contacts';
import DogDetail from 'pages/DogDetail/DogDetail';
import Gallery from 'pages/Gallery/Gallery';

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

function Content() {
    return (
        <Router>
            <NavBar />
            <div className={'app-wrapper'}>
                <div className={'app-content'}>
                    <Switch>
                        <Route exact path="/">
                            <ScrollToTop />
                            <Home />
                            <Footer />
                        </Route>
                        <Route exact path="/dogs">
                            <ScrollToTop />
                            {/*<Dogs />*/}
                            <MajorAndJazz/>
                            <Footer />
                        </Route>
                        <Route exact path="/gallery">
                            <ScrollToTop />
                            <Gallery />
                            <Footer />
                        </Route>
                        <Route exact path="/contacts">
                            <ScrollToTop />
                            <Contacts />
                        </Route>
                        <Route exact path={'/dogDetail/:dogId'}>
                            <ScrollToTop />
                            <DogDetail />
                            <Footer />
                        </Route>
                    </Switch>
                </div>
            </div>
        </Router>
    );
}

export default Content;
